import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconSocialInstagramSvg } from "./IconSocialInstagramSvg.mjs";
const IconSocialInstagram = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconSocialInstagramSvg, ...svgProps }) });
export {
  IconSocialInstagram
};
